import ErrorLogTable from './ErrorLogTable'

export default ErrorLogTable
